// extracted by mini-css-extract-plugin
export default {"logo":"logo__jPF5-","menu":"menu__lHSdu"};